import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { getTrackingConsent } from './utils/get-tracking-consent';

export const useConsentGatedAdobeScript = (src: string | undefined, enabled: boolean): void => {
  useEffect(() => {
    if (!enabled || !src) {
      return;
    }

    const loadScript = () => {
      if (getTrackingConsent() !== 'granted') {
        return;
      }
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      if (Array.from(document.scripts).some((existing) => existing.src === script.src)) {
        return;
      }
      script.onerror = () => {
        if (getTrackingConsent() === 'granted') {
          datadogRum.addError(new Error('Failed to load Adobe Launch script.'), {
            source: 'adobe-launch-script',
            scriptUrl: script.src,
          });
        }
      };
      document.head.appendChild(script);
    };

    window.addEventListener('OneTrustGroupsUpdated', loadScript);
    window.addEventListener('OTConsentApplied', loadScript);
    loadScript();
    return () => {
      window.removeEventListener('OneTrustGroupsUpdated', loadScript);
      window.removeEventListener('OTConsentApplied', loadScript);
      // Loaded code cannot be unloaded; Launch rules must enforce consent on every beacon.
    };
  }, [src, enabled]);
};
